module.exports = __webpack_public_path__ + "img/dianjiyun5.84a12c19.png";